import * as types from './mutation-types';

export const getProductionPlanningData = ({commit}) => {
    const response = {
        summary: {
            grower: 'MMJ',
            facility: 'Denver',
            address: '145 Milk Rd',
            upcomingPlantingDecision: 1, // TODO we dont need this as we can use productionPlanning.summary.upcomingDecisions.length
            currentUnusedBasins: 1,
            harvestedBasinsThisWeek: 5,
            strains: [
                {name: 'OJ Kush', color: '#522586'}, {name: 'Purple Haze', color: '#3BB34A'},{ name: 'Pineapple Skunk', color: '#F6A623'}, {name: 'AK-47', color: '#8CC541'}
            ],
            upcomingDecisions: [
                {
                    area: 'Zone 2',
                    basinLocation: 'R1C2T',
                    expectedHarvestDate: 'Dec 12th',
                    growplan: 'AK-47 Flower 1',
                    strain: 'AK-47',
                    expectedYield: '22 lb',
                    decisionDate: 'Nov 26 (8 days)',
                    expectedVegetationTransplantDate: 'Dec 12',
                    expectedHarvestOfReplant: 'Feb 15',
                    replantStrain: 'AK-47',
                    expectedYieldOfReplant: '22 lb / 4 lb'

                },
                {
                    area: 'Zone 3',
                    basinLocation: 'R1C5B',
                    expectedHarvestDate: 'Dec 15th',
                    growplan: 'Silver Haze Trim Q 1',
                    strain: 'Silver Haze',
                    expectedYield: '3 lb',
                    decisionDate: 'Nov 30 (11 days)',
                    expectedVegetationTransplantDate: 'Dec 15',
                    expectedHarvestOfReplant: 'Feb 20',
                    replantStrain: 'OJ Kush',
                    expectedYieldOfReplant: '22 lb / 4 lb'

                }
            ]

        }
    }
    commit(types.GET_PRODUCION_PLANNING_DATA, response);
}
